import { render, staticRenderFns } from "./MyApplyWait.vue?vue&type=template&id=3504e906&scoped=true"
import script from "./MyApplyWait.vue?vue&type=script&lang=js"
export * from "./MyApplyWait.vue?vue&type=script&lang=js"
import style0 from "./MyApplyWait.vue?vue&type=style&index=0&id=3504e906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3504e906",
  null
  
)

export default component.exports